<template>
    <section class="app-main">

        <div class="top-bar">
            <el-button  class="top-btn" type="primary" plain @click="handleShow()" style="width:120px">添加</el-button>
        </div>

        <el-card>
            <el-table :data="tableData" row-key="id" empty-text="暂无类目" max-height="650"  style="width:100%;">
                <el-table-column type="selection"  width="100"  align="center"> </el-table-column>
                <el-table-column prop="title"      label="名称" align="center"  ></el-table-column>
                <el-table-column prop="sort_id"    label="排序" align="center" >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sort_id" @change="handleSort(scope.row)" size="small" style="width:100px"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="status"    label="栏目状态"    width="160"   align="center" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" @change="handleStatus(scope.row)" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="small"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="small"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        


        <!-- 修改角色的弹框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="800px" center>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>栏目名称：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="name" placeholder="请输入栏目名称"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>栏目排序：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="sort" placeholder="请输入排序(正序排列)"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>栏目状态：</p>
                </el-col>
                <el-col :span="18">
                    <el-radio v-model="status" :label="1" border>启用</el-radio>
                    <el-radio v-model="status" :label="0" border>禁用</el-radio>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleBtn">确 定</el-button>
            </div>
        </el-dialog>


    </section>
</template>


<script>
import { category_list, category_add, category_put, category_del } from '@/api/merchant.js'

export default {
    data() {
        return {
            tableData: [],
            dialog:false,    // 控制显示 添加修改弹窗
            dialogTitle:'添加栏目',
            id:'',           //  有id 是修改  没有id是添加
            name:'',
            sort:1,
            status:0,
        }
    },
    methods: {
        // 获取栏目数据
        handleData(){
            category_list().then(res => {
                if(res){
                    this.tableData = res.data;
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 显示添加修改弹窗
        handleShow(row){
            if(row){
                this.dialog      = true
                this.dialogTitle = '修改栏目'
                this.id        = row.id
                this.name      = row.title
                this.sort      = row.sort_id
                this.status    = row.status
            }else{
                this.dialog      = true
                this.dialogTitle = '添加栏目'
                this.id        = ''
                this.name      = ''
                this.sort      = ''
                this.status    = 1
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        // 添加栏目函数
        handleAdd(){
            let params = {
                title:this.name,
                pid:0,
                sort_id:this.sort,
                status:this.status,
                depth: 1
            }
            category_add(params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改栏目函数
        handlePut(){
            let params = {
                title:this.name,
                pid:0,
                sort_id:this.sort,
                status:this.status,
                depth: 1
            }
            category_put(this.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                    
                }
            })
        },
        // 修改排序
        handleSort(row){
            let params = {
                sort_id:row.sort_id
            }
            category_put(row.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改状态
        handleStatus(row){
            let params = {
                status:row.status
            }
            category_put(row.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
         // 点击删除 
        handleDel(item){
            console.log(item)
            this.$confirm(`此操作将删除类目：${item.title}，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                category_del(item.id).then(res => {
                    if(res ){
                        this.$message({type:'success',message:res.msg,duration:1500})
                        this.handleData()
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },

        
        addMeau(){

        },
        editMeau(){

        },
    },
    created(){
        this.handleData();
    },
    activated() {
        this.handleData()
    },
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 80px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
    }
</style>